// extracted by mini-css-extract-plugin
module.exports = {"desktopHeader":"header_desktopHeader__GBvbs","title":"header_title__2ydrI"};